// extracted by mini-css-extract-plugin
var _1 = "ImageCell_image__ZxgVU";
var _2 = "ImageCell_imageWrapper__82APx";
export { _1 as "image", _2 as "imageWrapper" }
